import React, { useEffect, useState } from 'react';
// import { Country } from "country-state-city";
import { FaRegEdit } from "react-icons/fa";
import InputField from '../../../../lib/ui/inputs/Input';
import { Chip, Select, MenuItem, FormControl, Checkbox, OutlinedInput, ListItemText, InputAdornment } from '@material-ui/core';
import { IoMdClose } from "react-icons/io";
import currency from '../../../../config/currency.json'
import { LuPlus } from "react-icons/lu";
import "../../../../ui-styles/tooltips/tooltips.css";
import { makeStyles } from '@material-ui/core/styles';
import { getAxios } from "../../../../actions/appointment";
// import CurrencySymbol from 'currency-symbol';
const useStyles = makeStyles({
  menuItem: {
    padding: '0px 8px 0px 16px',
  },
});

const AddCurrency = ({addChips, setAddChips, defaultCurrency, setDefaultCurrency, defaultAmount, setDefaultAmount,errorMsg, setErrorMsg, defaultFee, setDefaulFee}) => {
  const classes = useStyles();
  const [filteredCountryOptions, setFilteredCountryOptions] = useState([]);
  const [editFilteredCountry, setEditFilteredCountry] = useState([]);
  const [selectedCountries, setSelectedCountries] = useState([]);
  const [selectedCurrencies, setSelectedCurrencies] = useState([]);
  const [addCurrency, setAddCurrency] = useState(false);
  const [currencyType, setCurrencyType] = useState('');
  const [currencySymbol, setCurrencySymbol] = useState('');
  const [currencyValue, setCurrencyValue] = useState('');
  const [defaultDisable, setDefaultDisable] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editingChipIndex, setEditingChipIndex] = useState(null);
  const [defaultCurr, setDefaultCurr] = useState(defaultCurrency);
  const [isEditingDefault, setIsEditingDefault] = useState(false);
  
  useEffect(() => {
    if (!isEditingDefault && defaultAmount) {
      setDefaultDisable(true); // Disable the field only when not editing
    }
  }, [isEditingDefault]);

  useEffect(() => {
    let updatedFilteredCountryOptions = countryOptions
    if(addChips.length > 0){
      const selectedCurrencyCodes = addChips.flatMap((chip) =>
        chip.country.map((c) => c.currencyCode)
      );
      updatedFilteredCountryOptions = countryOptions.filter(
        (country) => !selectedCurrencyCodes.includes(country.currencyCode)
      );
    }
    setFilteredCountryOptions(updatedFilteredCountryOptions);
    setEditFilteredCountry(updatedFilteredCountryOptions)
  }, [addChips]);

  useEffect(() => {
    if (selectedCountries.length > 0) {
      setCurrencyType(selectedCountries[0].currencyCode);
      setCurrencySymbol(selectedCountries[0].currencySymbol || '');
      const uniqueCountries = [
        ...new Map(selectedCountries.map((c) => [c.currencyCode, c])).values()
      ];
      setSelectedCurrencies(uniqueCountries);

    } else {
      setCurrencyType('');
      setCurrencySymbol('');
    }
  },[selectedCountries])

  const getSymbol = (currencyCode) => {
    const symboll = currency.find(item => item.code === currencyCode);
    return symboll ? symboll.symbol : ""; 
  };

  const currSymbol= getSymbol(defaultCurr)

  const handleText = (e) => {
    // const inputValue = e.target.value.replace(currSymbol, '').trim();
    // if (/^\d*$/.test(inputValue)) {
    //   setDefaultAmount(inputValue);
    // }
    const inputValue = e.target.value.trim();
    
    if (/^\d*\.?\d{0,3}$/.test(inputValue)) {
      setDefaultAmount(inputValue);
      setErrorMsg({...errorMsg, fee: "" })
    }
    
  };

  const onInputChange = (e) => {
    const value = e.target.value;
        if (/^\d*\.?\d*$/.test(value) && value.length <= 9) {
      handleText(e); 
    }
  };

  const handleMultiCurrencyValue=(e)=>{
    // const inputValue = e.target.value.replace(getSymbol(currencyType), '').trim();
    // if (/^\d*$/.test(inputValue)) {
    //   setCurrencyValue(inputValue);
    // }
    const inputValue = e.target.value.trim();
    if (/^\d*\.?\d{0,3}$/.test(inputValue)) {
      setCurrencyValue(inputValue);
    }
    
  }

  const onNewInputChange = (e) => {
    const value = e.target.value;
        if (/^\d*\.?\d*$/.test(value) && value.length <= 9) {
          handleMultiCurrencyValue(e); 
    }
  };

  // const handleEditCurrency = () => {
  //   setDefaultDisable(false);
  //   setIsEditingDefault(true);
  //   setAddCurrency(false);
  //   setDefaulFee(false)
  // }
  const handleEditCurrency = () => {
    setDefaultDisable(false); // Enable the field
    setIsEditingDefault(true); // Indicate editing mode
  };

  const handleCurrencyChange = (event) => {
    setCurrencyType(event.target.value);
    const selectedCountry = selectedCountries.find(option => option.currencyCode === event.target.value);
    setCurrencySymbol(selectedCountry ? selectedCountry.currencySymbol : '');
  };

  const handleDefaultCurrency = (event) => {
    const selectedCountry = countryOptions.find(country => country.countryCode === event.target.value);
    setDefaultCurr(selectedCountry.currencyCode)
    setDefaultCurrency(event.target.value);
  };
  
  const handleChipClick = (chip, index) => {

    setCurrencyValue(chip.amount);
    setCurrencyType(chip.currency);
    const updatedCountries = [
      ...chip.country.filter(c => c.currencyCode === chip.currency),
      ...chip.country.filter(c => c.currencyCode !== chip.currency)
    ];
    setSelectedCountries(updatedCountries);
    setCurrencySymbol(chip.symbol); 
    setIsEditing(true); 
    setEditingChipIndex(index); 
    const chipCountries = chip.country;
    const updatedFilteredCountryOptions = [
      ...chipCountries, 
      ...filteredCountryOptions 
    ]
    setEditFilteredCountry(updatedFilteredCountryOptions);
  };

  const handleCurrency = async (currency, fee, type) => {
    if (currency === "USD") {
      const errorMessage = fee < 0.50 ? `Please enter a fee greater than 0.50 USD` : "";
      const errorObject = type === "fee" ? { fee: errorMessage } : { newFees: errorMessage };
      setErrorMsg({ ...errorMsg, ...errorObject });
      return fee >= 0.50;
    } else {
      let from = currency.toLowerCase();
      try {
          const res = await getAxios(from);
          const exchangeRate = res.data[from].usd;
          const result = fee * exchangeRate;
          const errorMessage = result < 0.50 
              ? `Please enter fee more than ${Math.ceil(0.50 / exchangeRate)} ${currency}` 
              : "";
          const errorObject = type === "fee" 
              ? { fee: errorMessage } 
              : { newFees: errorMessage };
          setErrorMsg({ ...errorMsg, ...errorObject });
          return result >= 0.50;
      } catch (err) {
          console.error("Error fetching currency data:", err);
          return false;
      }
    }
};

const handleAddCurrency = async() => {
  const valid = await handleCurrency(defaultCurr,defaultAmount, "fee" )
  if(valid){
    setDefaultDisable(true);
    setAddCurrency(true);
    setDefaulFee(true);
  }
};

const handleAddChip = async () => {
  const valid = await handleCurrency(currencyType, currencyValue, "fees")
    if (currencyType && currencyValue && valid) {
      if (isEditing) {
        const updatedChips = addChips.map((chip, index) => {
          if (index === editingChipIndex) {
            return { currency: currencyType, amount: currencyValue, symbol: currencySymbol, country: selectedCountries };
          }
          return chip;
        });
        setAddChips(updatedChips);
        setIsEditing(false); 
        setEditingChipIndex(null);
      } else {
        setAddChips(prev => [
          ...prev,
          { currency: currencyType, amount: currencyValue, symbol: currencySymbol, country: selectedCountries }
        ]);
      }
      setCurrencyValue('');
      setCurrencyType('');
      setSelectedCountries([]);
    }
  };

  const preventInvalidChars = (e) => {
    const invalidChars = ["e", "E", "+", "-"];
    if (invalidChars.includes(e.key)) {
      e.preventDefault();
    }
  };

  const countryOptions = currency.map((country) => ({
    value: country.countryCode,
    label: `${country.country}`,
    countryCode: country.countryCode,
    currencyCode: country.code,
    currencySymbol: country.symbol || '',
  }));

  const remainingCount = selectedCountries.length - 1;

  return (
    <>
      <small className="inpLabel">Consultation Fee:<span className="redTxt">*</span>:</small>
      <div className="inputRowFeild medicalInputs">
        <div className="hozRadioGroupOne pdngVSX">
          <div className='pdngHztSM currencyWdth disableMode'>
            <InputField
              placeholder='Default'
              type="text"
              value='Default'
              disabled={true}
              pattern="[0-9]{2,5}"
            />
          </div>
          <div className={`pdngHztSM currencyWdth ${defaultDisable ? "disableMode" : ""}`}>
            <FormControl variant="outlined" fullWidth disabled={defaultDisable}>
              <Select
                value={defaultCurrency}
                onChange={handleDefaultCurrency}
                displayEmpty
                disabled={defaultDisable}
                input={<OutlinedInput placeholder="Select Currency" />}
                className='currencySelect'
              >
                <MenuItem disabled value="">
                  <span>Select Currency</span>
                </MenuItem>
                {countryOptions.map((country) => {
                  return (
                    <MenuItem key={country.countryCode} value={country.countryCode}>
                       {country.countryCode} ({country.currencySymbol})
                    </MenuItem>
                  );
                })} 
              </Select>
            </FormControl>
          </div>
          <div className={`pdngHztSM currencyWdth alignCenter ${defaultDisable ? "disableMode" : ""}`}>
            <FormControl fullWidth className={classes.margin} variant="outlined">
              <OutlinedInput
                id="outlined-adornment-amount"
                value={`${defaultAmount}`}
                style={{background:'#fff',height:'40px'}}
                onChange={onInputChange}
                length={8}
                startAdornment={<InputAdornment position="start">{currSymbol}</InputAdornment>}
                placeholder='Amount'
                onKeyDown={preventInvalidChars}
              />
            </FormControl>
        </div>
              {defaultDisable ?
              <div className={`plusBg cursorPointer ${(defaultAmount && defaultCurr) ? '' : 'disableMode'}`} onClick={handleEditCurrency}tooltip='Edit'>
                  <FaRegEdit fontSize={18} />
              </div> :
              <div className={`plusBg cursorPointer ${(defaultAmount && defaultCurr) ? '' : 'disableMode'}`} onClick={handleAddCurrency} tooltip='Add Default Fee'>
                  <LuPlus fontSize={18} />
              </div>}
        </div>
        {(errorMsg && errorMsg.fee) && <span className="inputErrorMsg mrgLeft8">{errorMsg.fee}</span>}
        {addChips && <div className="hozRadioGroupOne pdngVSX">
          <div className="pdngHztSM currencyWdth">
            <FormControl variant="outlined" fullWidth>
              <Select
                multiple
                displayEmpty
                value={selectedCountries}
                input={<OutlinedInput placeholder="Select Country" />}
                className='currencySelect '
                renderValue={(selected) => {
                  if (selected.length === 0) {
                    return <span>Select Country</span>;
                  }
                  return (
                    <div className="selected-countries">
                        <span className="country-label wordBreak" >
                          {selectedCountries[0].label}
                        </span>
                      {remainingCount > 0 && (
                        <span className="country-label more-countries primaryTxt">
                          {` +${remainingCount}`}
                        </span>
                      )}
                    </div>
                  );
                }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 340,
                      width: 250,
                    },
                  },
                }}
              >
                <MenuItem disabled value="">
                  <span>Select Country</span>
                </MenuItem>
                {editFilteredCountry?.map((country) => (
                  <MenuItem key={country.value} value={country} classes={{ root: classes.menuItem }}>
                    <div className='flexRow'>
                      <div className="flexMinWidthRow wordBreak whtspace">
                        <ListItemText primary={country.label} />
                      </div>
                      <div className='flexAutoRow'>
                        <Checkbox
                          checked={selectedCountries.some(selected => selected.value === country.value)}
                          onChange={(e) => {
                            if (e.target.checked) {
                              if (!selectedCountries.some(selected => selected.value === country.value)) {
                                setSelectedCountries([...selectedCountries, country]);
                              }
                            } else {
                              setSelectedCountries(selectedCountries.filter(selected => selected.value !== country.value));
                            }
                          }}
                        />
                      </div>
                    </div>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className="respdngHztSM currencyWdth">
            {selectedCurrencies.length === 1 ? (
              <FormControl variant="outlined" fullWidth>
                <OutlinedInput
                  className='currencySelect'
                  value={`${currencyType} ${currencySymbol}`}
                  placeholder="Currency"
                />
              </FormControl>
            ) : (
              <FormControl variant="outlined" fullWidth>
                <Select
                  value={currencyType} 
                  onChange={handleCurrencyChange}
                  displayEmpty
                  className="currencySelect"
                  input={<OutlinedInput placeholder="Select Currency" />}
                >
                  <MenuItem disabled value="">
                    <span>Select Currency</span>
                  </MenuItem>
                  {selectedCurrencies.map((country, index) => (
                    <MenuItem key={index} value={country.currencyCode}>
                      {country.currencyCode} ({country.currencySymbol})
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </div>
          <div className="pdngHztSM currencyWdth alignCenter">
         <FormControl fullWidth className={classes.margin} variant="outlined">
          <OutlinedInput
            id="outlined-adornment-amount"
            value={`${currencyValue}`}
            style={{background:'#fff',height:'40px'}}
            onChange={onNewInputChange}
            length={8}
            startAdornment={<InputAdornment position="start">{currencySymbol}</InputAdornment>}
            placeholder='Amount'
            onKeyDown={preventInvalidChars}
          />
        </FormControl>
          </div>
          {addChips && <div className={`plusBg cursorPointer ${(currencyValue && currencyType) ? '' : 'disableMode'}`} tooltip="Add Consultation Fee" onClick={handleAddChip}>
            <LuPlus fontSize={18} />
          </div>}
        </div>}
        {(errorMsg?.newFees && errorMsg?.newFees !== "") && <span className="inputErrorMsg mrgLeft8">{errorMsg.newFees}</span>}
        {addChips.length > 0 && <div className="hozRadioGroup">
          {addChips.map((data, index) => (
            <div className="chippdng" key={index}>
              <Chip
                label={<div className="hozRadioGroup">
                  <span className="pdngHztSM">{data.currency} {data.symbol} {data.amount}</span>
                </div>}
                onClick={() => handleChipClick(data, index)}
                onDelete={() => {
                  if(editingChipIndex === index){
                    setCurrencyValue('');
                    setCurrencyType('');
                    setSelectedCountries([]);
                    setCurrencySymbol(''); 
                    setEditingChipIndex(null)
                    setIsEditing(false)
                  }
                  const updatedChips = addChips.filter((_, chipIndex) => chipIndex !== index);
                  setAddChips(updatedChips);
                }}
                deleteIcon={<IoMdClose style={{ height: 12, color: '#000' }} />}
                className="chipsBg"
              />
            </div>
          ))}
        </div>}
      </div>
    </>
  );
};

export default AddCurrency;
